export default __webpack_public_path__ + "static/media/cart3.9d6edaf1.jpg";